import React, { useCallback, useRef } from 'react';
import TextField from 'studio/components/TextField';
import Select from 'studio/components/Select';
import Progress from 'studio/components/Progress';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { creatableFileTypes, fileTypesWithFixedIdentifier } from 'studio/pages/Editor/FileTypeConstants';

const useStyles = makeStyles({
  root: { height: '165px !important', paddingTop: '7px !important' }
});

const CreateFileForm = ({
  createFile,
  fileIsCreating,
  newFileIdentifier,
  newFileType,
  setNewFileType,
  setFileIsCreating,
  setNewFileIdentifier
}) => {
  const classes = useStyles();

  const inputRef = useRef(null);

  const handleCreateClick = useCallback(() => {
    if (newFileIdentifier || fileTypesWithFixedIdentifier.has(newFileType)) {
      createFile();
      setNewFileType(null);
      setFileIsCreating(true);
      return;
    }
    inputRef.current.focus();
  }, [setNewFileType, setFileIsCreating, createFile, inputRef, newFileIdentifier]);

  const handleKeyPress = useCallback(
    event => {
      if (event.key === 'Enter') {
        handleCreateClick();
      }
    },
    [handleCreateClick]
  );

  return (
    <>
      <DialogTitle>Create file</DialogTitle>
      <DialogContent classes={classes}>
        {!fileIsCreating && (
          <form noValidate autoComplete="off">
            <Select
              name="type"
              value={newFileType}
              label="Type"
              description="The type of file to create"
              values={[...creatableFileTypes.keys()]}
              labels={[...creatableFileTypes.values()]}
              onChange={event => setNewFileType(event.target.value)}
            />

            <TextField
              ref={inputRef}
              autoFocus
              sx={{ marginTop: '10px' }}
              disabled={fileTypesWithFixedIdentifier.has(newFileType)}
              name="identifier"
              value={fileTypesWithFixedIdentifier.get(newFileType) || newFileIdentifier}
              label="Identifier"
              description="The identifier of the file"
              onChange={event => setNewFileIdentifier(event.target.value)}
              onKeyPress={handleKeyPress}
              data-test="editorNewFileIdentifier"
            />
          </form>
        )}
        {fileIsCreating && <Progress />}
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setNewFileType(null)} disabled={fileIsCreating}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleCreateClick}
          disabled={fileIsCreating}
          data-test="editorSubmitCreateNewFile"
        >
          Create
        </Button>
      </DialogActions>
    </>
  );
};

export default CreateFileForm;
